import _ from 'underscore';


function getCollectionAsset(data, validationPropsField) {
  const currentCollection = _.result(data, validationPropsField, []); // Currently filled headlines
  const currentCollectionAsset = _.pluck(currentCollection, 'Asset').filter(item => (item !== undefined && !_.isNull(item)));
  const currentCollectionAssetText = _.pluck(currentCollectionAsset, 'Text');
  return currentCollectionAssetText;
}

function getAvailableRecommendations(collectionRecommendations, currentCollectionAssetText) {
  return _.filter(collectionRecommendations, recommendation => recommendation && recommendation.Text && !_.contains(currentCollectionAssetText, recommendation.Text));
}
// TODO: will remodify when the data layer is ready
export function formatToLLMSuggestion(recommendationContext, data) {
  if (!recommendationContext.themes) return {};

  const llmSuggestions = {
    Perspectives: [], SuggestionLanguage: '', Suggestions: [], SummaryReason: 'summarized_reason',
  };
  const currentCollectionHeadlines = getCollectionAsset(data, 'Headlines');
  const currentCollectionDescriptions = getCollectionAsset(data, 'Descriptions');

  _.each(recommendationContext.themes, (theme) => {
    let { headlines, descriptions } = theme;
    const { name: Perspective } = theme;
    headlines = getAvailableRecommendations(headlines, currentCollectionHeadlines);
    descriptions = getAvailableRecommendations(descriptions, currentCollectionDescriptions);
    const headlineSuggestions = _.map(headlines, (headline) => {
      const { Text, SuggestionId } = headline;
      return {
        Asset: Text,
        AssetType: 'Headline',
        Perspective,
        Reason: '',
        SrcId: '',
        SuggestionId,
      };
    });
    const descriptionSuggestions = _.map(descriptions, (description) => {
      const { Text, SuggestionId } = description;
      return {
        Asset: Text,
        AssetType: 'Description',
        Perspective,
        Reason: '',
        SrcId: '',
        SuggestionId,
      };
    });
    llmSuggestions.Perspectives.push({ Perspective, PitchingPoint: '' });
    llmSuggestions.Suggestions.push(...headlineSuggestions, ...descriptionSuggestions);
  });
  return llmSuggestions;
}
